module.exports = __webpack_public_path__ + "static/media/alipay_logo.ed07c555.png";